import { motion } from "framer-motion";
import { WhatsAppButton } from "./WhatsAppButton";
import { Sparkles } from "lucide-react";

export const FinalCTA = () => {
  return (
    <section className="relative overflow-hidden px-5 py-24 md:px-10 md:py-32">
      <div className="aurora left-[10%] top-[20%] h-80 w-80 bg-[#3B82F6]" />
      <div className="aurora right-[10%] bottom-[10%] h-80 w-80 bg-[#60A5FA]" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="relative mx-auto max-w-4xl overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-br from-[#0B111E] to-[#060A14] p-10 text-center md:p-16"
      >
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative">
          <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2">
            <Sparkles className="h-4 w-4 text-[#60A5FA]" />
            <span className="text-xs font-semibold text-gray-200">Begrenzte Fahrer-Plätze pro Region</span>
          </div>
          <h2 className="font-heading text-3xl font-extrabold leading-tight tracking-tight text-white md:text-5xl">
            Bereit für deinen <span className="gradient-text">ersten Auftrag?</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base text-gray-300 md:text-lg">
            Schreib uns jetzt auf WhatsApp – wir melden uns direkt zurück und du kannst noch diese Woche deine erste Tour übernehmen.
          </p>
          <div className="mt-9 flex justify-center">
            <WhatsAppButton size="lg" testid="final-whatsapp" label="Jetzt auf WhatsApp starten" pulse />
          </div>
        </div>
      </motion.div>
    </section>
  );
};
